export default "__VITE_ASSET__1b58ed39__"